import { AxiosResponse } from "axios";

export const codeSuccess: number[] = [
  200, 201, 202, 203, 204, 205, 206, 207, 208, 226,
];

export enum axiosMethod {
  GET = "GET",
  POST = "POST",
  DELETE = "DELETE",
  PATCH = "PATCH",
  PUT = "PUT",
}

export class HttpResponse<TData> {
  readonly error?: boolean;
  readonly data: TData;
  readonly errorCode: string;
  readonly errorMsg: string;
  readonly status: number;

  constructor(response?: AxiosResponse, entityClass?: any) {
    this.data = response?.data
      ? entityClass
        ? new entityClass(response.data)
        : response.data
      : entityClass
      ? new entityClass()
      : response?.data;
    this.errorCode = response?.data?.code || response?.data?.error || "";
    this.errorMsg =
      response?.data?.message || response?.data?.error_description || "";
    this.status = response?.status || 0;
    this.error = !codeSuccess.includes(Number(response?.status) || 0);
  }
}

export class SearchResponse<TData> {
  data: TData[] = [];
  readonly status: number = 0;
  readonly errorCode: string;
  readonly errorMsg: string;
  readonly error?: boolean;
  readonly nextLink: string;
  readonly total: number;

  constructor(
    response?: AxiosResponse,
    entityClass?: any,
    isNotOdata?: boolean
  ) {
    if (isNotOdata) {
      const dataClone = response?.data?.data
        ? response?.data?.data
        : response?.data;
      this.data = dataClone.length
        ? entityClass
          ? dataClone.map((item: any) => new entityClass(item))
          : dataClone
        : [];
      this.total = response?.data?.metadata
        ? response?.data?.metadata.total
        : 0;
    } else {
      this.data = response?.data?.value
        ? entityClass
          ? response.data.value.map((item: any) => new entityClass(item))
          : response.data.value
        : [];
      this.total =
        response?.data && response?.data["@odata.count"]
          ? response.data["@odata.count"]
          : 0;
    }
    this.status = response?.status || 0;
    this.errorCode = response?.data?.code || response?.data?.error?.code || "";
    this.errorMsg =
      response?.data?.message || response?.data?.error?.message || "";
    this.error = !codeSuccess.includes(Number(response?.status) || 0);
    this.nextLink =
      response?.data && response?.data["@odata.nextLink"]
        ? response.data["@odata.nextLink"]
        : "";
  }
}
